export default __webpack_public_path__ + "static/media/banner-realistic.7063ae08.jpg";